module.exports = __webpack_public_path__ + "media/images/admin/icons/repeat-4a7258559f9d1560761883ee3f5c0751.svg";